// Mock data for ERBA landing page
export const mockData = {
  contact: {
    phone: "644 348 937",
    email: "info@erbaservice.com",
    address: "Calle Ntra. Señora de las Nieves. Edf. Piscis Local 4. CP. 29770 Torrox, (Málaga)",
    hours: "Lunes a Viernes 9:00 a 18:00, Sábados 9:00 a 14:00",
    whatsapp: "34644348937"
  },
  
  services: [
    {
      id: 1,
      title: "Mantenimiento preventivo y correctivo",
      description: "Revisiones programadas y reparaciones para mantener tu maquinaria en óptimas condiciones",
      icon: "Settings"
    },
    {
      id: 2,
      title: "Reparación de maquinaria agrícola y de jardín",
      description: "Especialistas en pequeñas máquinas agrícolas, desbrozadoras, motosierras, cortacesped y todo tipo de equipos",
      icon: "Wrench"
    },
    {
      id: 3,
      title: "Venta de repuestos",
      description: "Stock de repuestos originales y alternativos de las mejores marcas",
      icon: "Package"
    },
    {
      id: 4,
      title: "Trabajos y piezas garantizadas",
      description: "Garantía completa en todos nuestros servicios y repuestos instalados",
      icon: "Shield"
    }
  ],

  values: [
    {
      title: "Eficiencia",
      description: "Reparaciones rápidas para minimizar el tiempo de parada",
      icon: "Zap"
    },
    {
      title: "Confianza",
      description: "Experiencia y equipo respaldando nuestro trabajo",
      icon: "Heart"
    },
    {
      title: "Precios justos",
      description: "Transparencia total en costes y opciones competitivas",
      icon: "Euro"
    },
    {
      title: "Compromiso local",
      description: "Conocemos las necesidades de agricultores y jardineros de la zona",
      icon: "MapPin"
    }
  ],

  problems: [
    {
      problem: "Tiempo perdido por averías",
      solution: "Reparación rápida y efectiva",
      description: "Nuestro servicio técnico especializado minimiza el tiempo de inactividad"
    },
    {
      problem: "Dificultad con repuestos",
      solution: "Stock inmediato y alternativas",
      description: "Amplio inventario de piezas originales y compatibles disponibles"
    },
    {
      problem: "Costes elevados",
      solution: "Opciones competitivas y transparentes",
      description: "Presupuestos claros con alternativas económicas sin comprometer calidad"
    },
    {
      problem: "Fallos recurrentes",
      solution: "Garantía en cada servicio",
      description: "Compromiso total con la calidad y durabilidad de nuestras reparaciones"
    }
  ],

  beforeAfter: [
    {
      id: 1,
      title: "Motosierra STIHL",
      before: "Motor sin arrancar, cadena desafilada",
      after: "Completamente funcional, motor optimizado"
    },
    {
      id: 2,
      title: "Cortacésped Honda",
      before: "Corte irregular, motor humeando",
      after: "Corte perfecto, motor como nuevo"
    },
    {
      id: 3,
      title: "Desbrozadora Husqvarna",
      before: "Vibración excesiva, pérdida de potencia",
      after: "Funcionamiento suave, potencia completa"
    },
    {
      id: 4,
      title: "Soplador de hojas",
      before: "Sin potencia de soplado, ruido excesivo",
      after: "Máxima potencia, funcionamiento silencioso"
    }
  ],

  testimonials: [
    {
      name: "Juan Carlos Pérez",
      business: "Finca Los Mangos",
      text: "ERBA ha mantenido toda mi maquinaria agrícola en perfecto estado durante años. Su rapidez y profesionalidad son excepcionales.",
      rating: 5
    },
    {
      name: "María González",
      business: "Jardines Costa del Sol",
      text: "El mejor taller de la zona. Siempre encuentran la solución más económica sin comprometer la calidad del trabajo.",
      rating: 5
    },
    {
      name: "Antonio Ruiz",
      business: "Vivero La Axarquía",
      text: "Servicio rápido y precios justos. Su stock de repuestos me ha salvado muchas veces en temporada alta.",
      rating: 5
    }
  ]
};